"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Cell = function (props) {
    var onCellClick = props.onCellClick, onCellEnter = props.onCellEnter, onCellLeave = props.onCellLeave, content = props.content, data = props.data;
    return (React.createElement("div", { className: "cell-data-wrap", onClick: onCellClick ? function () { return onCellClick(data); } : undefined, onMouseEnter: onCellEnter ? function () { return onCellEnter(data); } : undefined, onMouseLeave: onCellLeave ? function () { return onCellLeave(data); } : undefined }, content));
};
exports.default = Cell;
//# sourceMappingURL=Cell.js.map